<template>
    <section class="w-full">
        <div class="pda-default">
            <form @submit.prevent="next()" novalidate>
            <div class="t-headline5">
                {{$t('1549')}}
                <!-- 코드 인증 -->
            </div>
            <div class="t-body3 mgt-6 t-color-content1" v-html="$t('762', {str1: `<strong>${join.dutyName}</strong>`, str2: `<strong>${join.responsibilityName}</strong>`})">
                <!-- 직무 A 직책 B 에 해당하는 인증코드를 입력하세요. -->
            </div>
            <div class="mgt-35">
                <div class="mdc-text-field mdc-text-field--outlined mdc-text-field--with-trailing-icon w-full"
                    :class="submitState && codeInvalidCheck ? 'mdc-text-field--invalid' : ''"
                    id="codeEl"
                >
                    <i class="material-icons mdc-text-field__icon">
                        {{validIcon}}
                    </i>
                    <input type="text" class="mdc-text-field__input"
                        v-model="code"
                        v-validate="'required|alpha_num'"
                        ref="code"
                        id="code"
                        name="code"
                        maxlength="50"
                    >
                    <div class="mdc-notched-outline">
                        <div class="mdc-notched-outline__leading"></div>
                        <div class="mdc-notched-outline__notch">
                        <label for="tf-outlined" class="mdc-floating-label">
                            {{$t('763')}}
                            <!-- 코드입력 -->
                        </label>
                        </div>
                        <div class="mdc-notched-outline__trailing"></div>
                    </div>
                    
                </div>
                <div class="t-helper mgl-7 mgr-7 pdt-2 min-h-23" :class="submitState && codeInvalidCheck ? 't-color-red1' : ''">
                    <span v-if="submitState && codeInvalidCheck">
                        {{$t('1552')}}
                        <!-- * 공백이 없는 인증코드를 입력하세요. -->
                    </span>
                    <span v-else>
                        {{$t('1552')}}
                        <!-- * 본인 및 소속을 확인하기 위한 코드 인증입니다. -->
                    </span>
                </div>
            </div>

            <div class="mgt-50">
                <button class="mdc-button mdc-button--raised btn-red" @click="next()">
                    {{$t('1553')}}
                    <!-- 다음 -->
                </button>
                <button class="mdc-button btn-white mgr-8 mgl-8" @click="cancelJoin()" type="button">
                    {{$t('1554')}}
                    <!-- 취소 -->
                </button>
            </div>
            </form>

            <div class="mgt-30 t-body4 t-color-gray1">
                <a @click="showMessage(1)">
                    {{$t('763')}}
                    <!-- 인증코드를 잊음 -->
                </a>
                {{$t('1556')}}
                    <!-- 혹은 -->
                <a @click="showMessage(2)">
                    {{$t('765')}}
                    <!-- 인증코드가 없음 -->
                </a>
            </div>

        </div>

        
    </section>
    
</template>

<script>
/**
 * 회원가입 - 코드인증 컴포넌트(sign up - auth code component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import {MDCTextField} from '@material/textfield'
import {MDCRipple} from '@material/ripple'
import joinApi from '@/api/joinApi.js'
import {mapState, mapMutations} from 'vuex'
import {joinMixin} from '@/mixins/join.js'

export default {
    data() {
        return {
            code: '',
            codeTextField: null,
            submitState: false,
            validIcon: ''
        }
    },

    mixins: [joinMixin],
    
    computed : {
        ...mapState('join',{
            join : state => state,
        }),
       
        // code 유효성 Check 및 아이콘(validation code & set icon)
        codeInvalidCheck() {
            let returnValue = false
            if (this.submitState) {
                if (this.errors.has('code')) {
                    returnValue = true
                    this.validIcon = 'warning'
                }else {
                    returnValue = false
                    this.validIcon = ''
                }
            }
            this.codeTextField.valid === !returnValue ? '' : this.codeTextField.valid = !returnValue
            return returnValue
        },

    },
    created() {
        if (!this.join.responsibility) {
            this.moveJoin2Intro()
        }
    },
    mounted() {
        this.setMaterialUi()
        this.$refs.code.focus()
    },

    methods: {
        // Store 변이 정의(define store mutation)
        ...mapMutations('join', ['SET_RESPONSIBILITY', 'SET_CODE']),

        setMaterialUi() {
            this.codeTextField = new MDCTextField(document.querySelector('#codeEl'))
            this.codeTextField.useNativeValidation = false
            const buttonRipple = [].map.call(document.querySelectorAll('.mdc-button'), function(el) {
                let button = new MDCRipple.attachTo(el)
                return button
            })
        },

        // 다음(move next)
        next() {
            this.$validator.validateAll().then((resultValid) => {
                this.submitState = true

                if (resultValid) {
                    let params = {
                        responsibility: this.join.responsibility,
                        code: this.code
                    }

                    // code auth
                    joinApi.authResponsibility(params).then((response) => {
                        this.SET_CODE(this.code)
                        if (this.join.socialLink.type === 'google' || this.join.socialLink.type === 'facebook' || this.join.socialLink.type === 'firebase') {
                            this.$router.push({
                                name: 'Join2SocialInput', query: this.$route.query
                            })
                        }else {
                            this.$router.push({
                                name: 'Join2Name', query: this.$route.query
                            })
                        }
                        
                    }).catch((err) => {
                        // this.$snackOpen({contents:'인증에 실패했습니다. 코드를 확인해주세요.', btnDisplayYN: false}).then(() => {})
                        this.$snackOpen({contents: this.$t('1558') + ' ' + this.$t('1559'), btnDisplay:''}).then(() => {})
                    })
            
                } else{
                    this.focusFirstInvalidElement()
                }
            })
        },

    },

    

}
</script>